/** 双人协作：打开弹窗时曾处于可操作态，他人改单后提示文案 */

const orderLabel = (orderNo) => (orderNo ? `订单 ${orderNo}` : '该订单');

/** @param {object | undefined} result */
const operatorFromResult = (result) => result?.operator_name || result?.operator || '';

const getRecentOrderOperatorName = (order) => {
	if (!order) return '';
	return (
		operatorFromResult(order.approvedResult) ||
		operatorFromResult(order.deliveredResult) ||
		operatorFromResult(order.acceptedResult) ||
		operatorFromResult(order.placeOrderPaidResult) ||
		operatorFromResult(order.deliveryPaidResult) ||
		operatorFromResult(order.acceptPaidResult) ||
		''
	);
};

const withOperator = (text, order) => {
	const name = getRecentOrderOperatorName(order);
	return name ? `${text}（${name}）` : text;
};

const SILENT_COLLABORATION_PRESET = {
	showNotice: false,
	trackOpened: () => false,
	noticeWhen: () => false,
	message: () => null,
	tone: () => 'info',
	icon: () => 'circle-info',
};

export const isOrderDetailsMissingError = (error) => {
	const status = Number(error?.status || error?.originalStatus || 0);
	return status === 404;
};

const isWithdrawnCollaboration = (order, extras = {}) =>
	Boolean(extras.orderMissing || extras.approvalStatus === 'withdrawn' || order?.approvalStatus === 'withdrawn');

export const ORDER_COLLABORATION_PRESETS = {
	approval: {
		showNotice: true,
		trackOpened: (order) => order?.approvalStatus === 'inProcessOfApproval',
		noticeWhen: (order, opened, snapshot, extras = {}) => {
			if (!opened || !snapshot) return false;
			if (snapshot.approvalStatus !== 'inProcessOfApproval') return false;
			if (isWithdrawnCollaboration(order, extras)) return true;
			return order?.approvalStatus !== 'inProcessOfApproval';
		},
		message: (order, extras = {}) => {
			const label = orderLabel(order?.orderId || extras.orderId);
			if (isWithdrawnCollaboration(order, extras)) {
				return `${label} 已被撤回，已保存为草稿。同意/驳回不再有效。`;
			}
			if (order?.approvalStatus === 'approved' || order?.approvalStatus === 'systemApproved') {
				return withOperator(`${label} 已由他人审批通过`, order);
			}
			if (order?.approvalStatus === 'reject') {
				return withOperator(`${label} 已被他人驳回`, order);
			}
			return withOperator(`${label} 审批状态已更新`, order);
		},
		tone: (order, extras = {}) => {
			if (isWithdrawnCollaboration(order, extras)) return 'warning';
			return order?.approvalStatus === 'reject' ? 'danger' : 'success';
		},
		icon: (order, extras = {}) => {
			if (isWithdrawnCollaboration(order, extras)) return 'undo';
			return order?.approvalStatus === 'reject' ? 'circle-xmark' : 'circle-check';
		},
	},
	delivery: {
		...SILENT_COLLABORATION_PRESET,
	},
	payment: {
		...SILENT_COLLABORATION_PRESET,
	},
	accept: {
		...SILENT_COLLABORATION_PRESET,
	},
};

export const DEFAULT_ORDER_COLLABORATION_PRESET = {
	...SILENT_COLLABORATION_PRESET,
};

export const buildOrderCollaborationSnapshot = (order) => ({
	approvalStatus: order?.approvalStatus,
	orderId: order?.orderId,
});
